/**
 * Kbite "Notify me" modal — free plan has no app Custom CSS / branding toggle.
 * Modal may live in document or inside app-embed shadow roots; pierce both.
 */
(function () {
  if (window.__wdKbiteNotifyModalInit) return;
  window.__wdKbiteNotifyModalInit = true;

  var STYLE_ID = 'wd-kbite-notify-style';
  var STYLE_TEXT =
    '.modal-container{direction:rtl!important;text-align:right!important}' +
    '.modal-title,.notification-message,.privacy-text,.gw-success-message,.gw-success-message .success-text,.gw-success-message .close-text{text-align:right!important}' +
    '.email-input{text-align:right!important;direction:rtl!important}' +
    '.modal-container>div:has(.notify-button),.modal-container div[style*="justify-content"]{display:flex!important;width:100%!important;justify-content:flex-end!important}' +
    '.gw-branding-powered-by{display:none!important;visibility:hidden!important;height:0!important;margin:0!important;padding:0!important;overflow:hidden!important}' +
    '.modal-container .close-icon{right:auto!important;left:12px!important}';

  var DEBOUNCE_MS = 48;
  var fullScanTimer = null;
  var fullScanRaf = null;
  var clickPollTimer = null;
  var styledRoots = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var styledRootFallback = [];

  function rootHasStyle(root) {
    return root && root.querySelector && root.querySelector('#' + STYLE_ID);
  }

  function markStyled(root) {
    if (!root) return;
    if (styledRoots) styledRoots.add(root);
    else if (styledRootFallback.indexOf(root) === -1) styledRootFallback.push(root);
  }

  function isStyled(root) {
    if (!root) return false;
    if (styledRoots) return styledRoots.has(root);
    return styledRootFallback.indexOf(root) !== -1;
  }

  /** Idempotent per document / shadow root / iframe document. */
  function injectStyle(root) {
    if (!root) return;
    if (isStyled(root) || rootHasStyle(root)) {
      markStyled(root);
      return;
    }
    var doc = root.nodeType === 9 ? root : root.ownerDocument || document;
    var style = doc.createElement('style');
    style.id = STYLE_ID;
    style.textContent = STYLE_TEXT;
    if (root.head) root.head.appendChild(style);
    else root.appendChild(style);
    markStyled(root);
  }

  function collectShadowRoots() {
    var roots = [];
    try {
      document.querySelectorAll('shopify-app, shopify-app-block, [class*="gw-"]').forEach(function (el) {
        if (el.shadowRoot) roots.push(el.shadowRoot);
      });
    } catch (e) {
      /* ignore */
    }
    return roots;
  }

  function eachRoot(fn) {
    fn(document);
    collectShadowRoots().forEach(fn);
    try {
      document.querySelectorAll('iframe').forEach(function (frame) {
        var doc = frame.contentDocument;
        if (doc) fn(doc);
      });
    } catch (e) {
      /* cross-origin iframe */
    }
  }

  function isNotifyModal(node) {
    return (
      node &&
      node.classList &&
      node.classList.contains('modal-container') &&
      node.querySelector &&
      node.querySelector('.notify-button')
    );
  }

  function getStyleRoot(modal) {
    var root = modal.getRootNode ? modal.getRootNode() : document;
    if (root && root.nodeType === 11) return root;
    if (root && root.nodeType === 9) return root;
    return document;
  }

  function removeBranding(scope) {
    if (!scope || !scope.querySelectorAll) return;
    if (scope.classList && scope.classList.contains('gw-branding-powered-by')) {
      scope.remove();
      return;
    }
    scope.querySelectorAll('.gw-branding-powered-by').forEach(function (el) {
      el.remove();
    });
  }

  function patchModal(modal) {
    if (!isNotifyModal(modal)) return;

    removeBranding(modal);

    if (modal.getAttribute('data-wd-kbite-patched') === '1') return;
    modal.setAttribute('data-wd-kbite-patched', '1');
    modal.setAttribute('dir', 'rtl');

    modal.style.setProperty('direction', 'rtl', 'important');
    modal.style.setProperty('text-align', 'right', 'important');

    modal.querySelectorAll('.modal-title, .notification-message, .privacy-text, .email-input, .gw-success-message').forEach(function (el) {
      el.style.setProperty('text-align', 'right', 'important');
    });

    var email = modal.querySelector('.email-input');
    if (email) email.style.setProperty('direction', 'rtl', 'important');

    var notifyBtn = modal.querySelector('.notify-button');
    if (notifyBtn && notifyBtn.parentElement) {
      notifyBtn.parentElement.style.setProperty('display', 'flex', 'important');
      notifyBtn.parentElement.style.setProperty('width', '100%', 'important');
      notifyBtn.parentElement.style.setProperty('justify-content', 'flex-end', 'important');
    }

    var close = modal.querySelector('.close-icon');
    if (close) {
      close.style.setProperty('right', 'auto', 'important');
      close.style.setProperty('left', '12px', 'important');
    }
  }

  function patchModalTree(modal) {
    injectStyle(getStyleRoot(modal));
    patchModal(modal);
  }

  function findNotifyModalFromNode(node) {
    if (!node || node.nodeType !== 1) return null;
    if (isNotifyModal(node)) return node;
    if (node.closest) {
      var viaClosest = node.closest('.modal-container');
      if (viaClosest && isNotifyModal(viaClosest)) return viaClosest;
    }
    if (node.querySelector) {
      var list = node.querySelectorAll('.modal-container');
      for (var i = 0; i < list.length; i++) {
        if (isNotifyModal(list[i])) return list[i];
      }
    }
    return null;
  }

  function processAddedNode(node) {
    if (!node || node.nodeType !== 1) return { rootChanged: false };

    var rootChanged = false;

    if (node.shadowRoot) {
      injectStyle(node.shadowRoot);
      rootChanged = true;
    }
    if (node.tagName === 'IFRAME') rootChanged = true;

    removeBranding(node);

    var modal = findNotifyModalFromNode(node);
    if (modal) patchModalTree(modal);

    return { rootChanged: rootChanged };
  }

  function runFullScan() {
    eachRoot(function (root) {
      injectStyle(root);
      if (!root.querySelectorAll) return;
      root.querySelectorAll('.modal-container').forEach(patchModalTree);
      root.querySelectorAll('.gw-branding-powered-by').forEach(function (el) {
        el.remove();
      });
    });
  }

  function scheduleFullScan() {
    if (fullScanTimer) clearTimeout(fullScanTimer);
    fullScanTimer = setTimeout(function () {
      fullScanTimer = null;
      if (fullScanRaf) cancelAnimationFrame(fullScanRaf);
      fullScanRaf = requestAnimationFrame(function () {
        fullScanRaf = null;
        runFullScan();
      });
    }, DEBOUNCE_MS);
  }

  function onMutations(mutations) {
    var rootChanged = false;

    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      var j;
      for (j = 0; j < m.addedNodes.length; j++) {
        var added = m.addedNodes[j];
        if (added.nodeType !== 1) continue;
        var r = processAddedNode(added);
        if (r.rootChanged) rootChanged = true;
      }
      for (j = 0; j < m.removedNodes.length; j++) {
        var removed = m.removedNodes[j];
        if (removed.nodeType === 1 && (removed.shadowRoot || removed.tagName === 'IFRAME')) {
          rootChanged = true;
        }
      }
    }

    if (rootChanged) scheduleFullScan();
  }

  function queryNotifyModalsInRoot(root) {
    var found = false;
    if (!root || !root.querySelectorAll) return found;
    root.querySelectorAll('.modal-container').forEach(function (el) {
      if (isNotifyModal(el)) {
        patchModalTree(el);
        found = true;
      }
    });
    return found;
  }

  function pollForModal(attempt) {
    var found = queryNotifyModalsInRoot(document);
    if (!found) {
      collectShadowRoots().forEach(function (sr) {
        if (queryNotifyModalsInRoot(sr)) found = true;
      });
    }
    if (!found && attempt < 25) {
      clickPollTimer = setTimeout(function () {
        pollForModal(attempt + 1);
      }, 100);
    } else if (!found) {
      scheduleFullScan();
    }
  }

  function scheduleClickPoll() {
    if (clickPollTimer) clearTimeout(clickPollTimer);
    clickPollTimer = setTimeout(function () {
      clickPollTimer = null;
      pollForModal(0);
    }, 0);
  }

  function init() {
    runFullScan();
    var obs = new MutationObserver(onMutations);
    obs.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener(
      'click',
      function (e) {
        if (e.target && e.target.closest && e.target.closest('.gw-button-widget, .notify-button')) {
          scheduleClickPoll();
        }
      },
      true
    );
    window.addEventListener('load', scheduleFullScan);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
